<template>
  <div class="footer-socials">
    <ul class="footer-socials__list">
      <li
        v-for="item in socialList"
        :key="item.icon"
        class="footer-socials__item"
      >
        <UiBtn
          :href="item.href"
          :icon="item.icon"
          color="gray"
          icon-only
          target="_blank"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { facebook, instagram, telegram, viber } from '~/util/defaultInfo'

export default {
  name: 'FooterSocials',
  computed: {
    socialList() {
      return [
        { href: facebook, icon: 'socials/facebook' },
        { href: instagram, icon: 'socials/instagram' },
        { href: telegram, icon: 'socials/telegram' },
        { href: viber, icon: 'socials/viber' },
      ]
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
